@import "src/styles/common/_colors.scss";

.reportDialogHeader {
  align-items: center;
  justify-content: center;
}
.reportDialogFooter {
  button[class*="_buttonBlue_"] {
    margin-right: 10px;
    height: 24px;
    margin-top: 1px;
  }
}

.timePeriodWrapper {
  gap: 8px;
}

.spinner {
  [class*="spinner"] {
    font-size: 18px;
  }
}
.divider {
  border-right: 1px solid rgb(158, 156, 156);
  font-size: 9px;
  height: 12px;
  margin: 0px 10px;
}
.marginStyle {
  margin-top: 10px;
  margin-right: 8px;
}
.textAlign {
  gap: 6px;
  justify-content: start;
}
.dropdownFontStyle {
  font-size: 9px !important;
}
.fontStyle {
  font-size: 11px;
}
.disabledWrapper {
  cursor: not-allowed;
  & > * {
    pointer-events: none;
  }
}
